var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  forOwn = require('lodash/forOwn'),
  find = require('lodash/find');

var API_TAKE = 10,
  API_TAKE_ALL = null, // Backend prefers that we send null in order to get all courses.
  API_SKIP = 0,
  SHOW_ALL_KEY = 'Vis alle';

// Using string type for the
var FILTER_COMPLETED_COURSES = 'filter_completed',
  FILTER_UNCOMPLETED_COURSES = 'filter_uncompleted';

function MyCompletedCourses(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.completedCoursesIntroText = ko.observable(
    params.completedCoursesIntroText
  );
  this.completedCourses = ko.observableArray([]);
  this.selectedCourseFilter = ko.observable(FILTER_COMPLETED_COURSES);
  this.selectedOrganizer = ko.observable();
  this.organizers = ko.observableArray([]);
  this.isLoading = ko.observable(false);
  this.toggleAddExternalCourseButtonText = ko.observable(
    window.language.courses.addExternalCourse
  );
  this.showAddExternalCourse = ko.observable(false);
  this.showFetchAllCourses = ko.observable(false);
  this.hideSelect = ko.observable(false);
  this.selects = null;
  this.brightCoveNetCourseUrl =
    this.API.brightCoveNetCourseUrl + '?courseSequenceId=';
  this.activeModal = ko.observable(false);
  this.modalTitle = ko.observable('');
  this.modalText = ko.observable('');
  this.selectedSequenceId = ko.observable();
  this.selectedCourseFilter.subscribe(function() {
    this.selectedOrganizer(SHOW_ALL_KEY);
    this.getCourses(API_TAKE, API_SKIP);
    this.selects[0].selectize.setValue(SHOW_ALL_KEY);
  }, this);

  this.isLoading.subscribe(function(isLoading) {
    if (isLoading) {
      this.showFetchAllCourses(false);
    }
  }, this);

  this.showAddExternalCourse.subscribe(function(newVal) {
    this.toggleAddExternalCourse(newVal);
  }, this);
}

MyCompletedCourses.prototype.init = function(element) {
  this.$element = $(element);
  this.$extendedCourse = this.$element.find('.add-extended-course');
  this.getCompletedCourses(API_TAKE, API_SKIP);
  // Listen to modal/popup requests.
  ko.postbox.subscribe(
    'openPopup',
    function(value) {
      this.activeModal(!this.activeModal());
      this.modalTitle(value.modalTitle);
      this.modalText(value.modalText);
      this.selectedSequenceId(value.selectedSequenceId);
    }.bind(this)
  );
};

MyCompletedCourses.prototype.closeModal = function() {
  this.activeModal(false);
};

MyCompletedCourses.prototype.getCourses = function(take, skip) {
  if (this.selectedCourseFilter() === FILTER_COMPLETED_COURSES) {
    this.getCompletedCourses(take, skip);
  } else {
    this.getUncompletedCourses(take, skip);
  }
};

MyCompletedCourses.prototype.getAllCourses = function() {
  this.getCourses(API_TAKE_ALL, 0);
};

MyCompletedCourses.prototype.toggleAddExternalCourse = function(toggleState) {
  if (toggleState) {
    this.$extendedCourse.slideDown(250, 'easeOutQuad', function() {});
    this.toggleAddExternalCourseButtonText(window.language.courses.cancel);
  } else {
    this.$extendedCourse.slideUp(250, 'easeOutQuad', function() {});
    this.toggleAddExternalCourseButtonText(
      window.language.courses.addExternalCourse
    );
  }
};

MyCompletedCourses.prototype.getCompletedCourses = function(take, skip) {
  var self = this,
    url =
      this.API.completedCoursesUrl +
      '?skip=' +
      encodeURIComponent(skip) +
      '&take=' +
      encodeURIComponent(take);

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      self.handleCoursesSuccess(response, take, FILTER_COMPLETED_COURSES);
    },
    function() {
      self.isLoading(false);
    }
  );
};

MyCompletedCourses.prototype.getUncompletedCourses = function(take, skip) {
  var self = this,
    url =
      this.API.expiredButUncompletedCoursesUrl +
      '?skip=' +
      encodeURIComponent(skip) +
      '&take=' +
      encodeURIComponent(take);

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      self.handleCoursesSuccess(response, take, FILTER_UNCOMPLETED_COURSES);
    },
    function() {
      self.isLoading(false);
    }
  );
};

MyCompletedCourses.prototype.addedExternalCourse = function() {
  this.getCourses(API_TAKE, API_SKIP);
};

MyCompletedCourses.prototype.modifySpecificCourse = function(
  indexInCourses,
  indexInOrganizers,
  selectedOrganizer,
  updatedCourse
) {
  var tmpCoursesList = this.completedCourses();
  var courseToBeModified =
    tmpCoursesList[indexInCourses].organizersPerYear[selectedOrganizer][
      indexInOrganizers
    ];
  courseToBeModified.Course.CourseTitle = updatedCourse.title;
  courseToBeModified.Course.Organizer = updatedCourse.organizer;
  tmpCoursesList[indexInCourses].organizersPerYear[selectedOrganizer][
    indexInOrganizers
  ] = courseToBeModified;
  this.updateFilterOrganizers(tmpCoursesList, true);
};

MyCompletedCourses.prototype.updateFilterOrganizers = function(items) {
  var tmpResponse = [];
  var tmpOrganizersMap = {},
    tmpOrganizers = [];
  var self = this;
  items.forEach(function(item) {
    var organizersPerYear = {};

    // We want to pre sort the courses based on organizer for quick filtering.
    item.Courses.forEach(function(course) {
      if (organizersPerYear[course.Course.Organizer] === undefined) {
        organizersPerYear[course.Course.Organizer] = [];
      }
      organizersPerYear[course.Course.Organizer].push(course);
      tmpOrganizersMap[course.Course.Organizer] = course.Course.Organizer;
    });
    item.organizersPerYear = organizersPerYear;
    item.organizersPerYear[SHOW_ALL_KEY] = item.Courses;
    tmpResponse.push(item);
  });

  // Remap organizers to be used in selectize options.
  tmpOrganizers.push({
    text: SHOW_ALL_KEY,
    value: SHOW_ALL_KEY
  });
  forOwn(tmpOrganizersMap, function(value, key) {
    tmpOrganizers.push({
      text: key,
      value: key
    });
  });

  // Remap organizers to be used in selectize options.
  tmpOrganizers.push({
    text: SHOW_ALL_KEY,
    value: SHOW_ALL_KEY
  });
  forOwn(tmpOrganizersMap, function(value, key) {
    tmpOrganizers.push({
      text: key,
      value: key
    });
  });

  var organizersToRemove = [],
    organizersToAdd = [];
  var previousOrganizers = this.organizers();
  previousOrganizers.forEach(function(previousOrganizer) {
    if (
      find(tmpOrganizers, function(po) {
        return po.value === previousOrganizer.value;
      }) === undefined
    ) {
      organizersToRemove.push(previousOrganizer);
    }
  });

  tmpOrganizers.forEach(function(tmpOrganizer) {
    if (
      find(previousOrganizers, function(po) {
        return po.value === tmpOrganizer.value;
      }) === undefined
    ) {
      organizersToAdd.push(tmpOrganizer);
    }
  });

  this.organizers(tmpOrganizers);

  // Now that we have data we can stylize the select node to the selectize plugin.
  if (this.selects === null) {
    this.selects = this.$element
      .find('.form-select-wrapper-organizers')
      .selectize({
        valueField: 'value',
        labelField: 'text',
        options: tmpOrganizers
      });
    this.selects[0].selectize.setValue(SHOW_ALL_KEY);
  } else {
    this.selects[0].selectize.load(function() {
      organizersToRemove.forEach(function(organizerToRemove) {
        self.selects[0].selectize.removeOption(organizerToRemove.value);
      });
      organizersToAdd.forEach(function(organizerToAdd) {
        self.selects[0].selectize.addOption(organizerToAdd);
      });
    });
  }

  return tmpResponse;
};

MyCompletedCourses.prototype.handleCoursesSuccess = function(
  response,
  take,
  listType
) {
  if (listType === this.selectedCourseFilter()) {
    var tmpResponse = this.updateFilterOrganizers(response.Items);

    if (take === API_TAKE_ALL || take >= response.TotalItems) {
      this.showFetchAllCourses(false);
    } else {
      this.showFetchAllCourses(true);
    }

    this.completedCourses(tmpResponse);
    this.isLoading(false);
  }
};

module.exports = MyCompletedCourses;
